export const CUSTOM_FRAMEWORK_ENDPOINTS = {
  LIST: "/custom-frameworks",
  DETAIL: (id) => `/custom-frameworks/${id}`,
  CREATE: "/custom-frameworks",
  UPDATE: (id) => `/custom-frameworks/${id}`,
  DELETE: (id) => `/custom-frameworks/${id}`,

  DISCLOSURES: (frameworkId) => `/custom-frameworks/${frameworkId}/disclosures`,
  DISCLOSURE: (frameworkId, discId) =>
    `/custom-frameworks/${frameworkId}/disclosures/${discId}`,
  DISCLOSURES_BULK: (frameworkId) =>
    `/custom-frameworks/${frameworkId}/disclosures/bulk`,

  LOGO: (id) => `/custom-frameworks/${id}/logo`,
};
